export default [
  {
    path: "/forecast",
    name: "forecasting",
    icon: "bar-chart-2",
    component: () => import("@/views/forecast/ForecastWrapper.vue"),
    meta: {
      title: "Forecasting",
      ability: {
        action: ["read", "create"],
        subject: ["Forecast", "SaleForecastDaily"],
      },
    },
  }];
